import { Injectable } from '@angular/core';
// eslint-disable-next-line td-wb-rules/uirouter-import-rule
import { UIRouter } from '@uirouter/core';

import {
  PageLangService,
  // ActivityIndicatorService,
  RestErrorHandlerService,
  RestApplicationErrorHandlerService,
  SystemStatusChangeService,
  WebbrokerResponsiveService
} from '@tdwb/core';

/**
 * Initializes application after modules have been loaded before ui router starts listening
 */
@Injectable()
export class AttraderInitService {
  readonly INITIAL_ROUTE: string = '/page/attrader/agreements';

  constructor(private pageLangService: PageLangService,
              private systemStatusChangeService: SystemStatusChangeService,
              private restApplicationErrorHandlerService: RestApplicationErrorHandlerService,
              private restErrorHandlerService: RestErrorHandlerService,
              private webbrokerResponsiveService: WebbrokerResponsiveService,
              private uiRouter: UIRouter) {
  }

  init(bootstrapSuccess: boolean = true): void {
    if (bootstrapSuccess) {
      this.webbrokerResponsiveService.init();
      this.systemStatusChangeService.init();
      // this.activityIndicatorService.init(); // Commented out as the keep alive GET makes the bar show up all the time
      this.restErrorHandlerService.addHandler(this.restApplicationErrorHandlerService);
    }
    this.pageLangService.init();
    this.uiRouter.urlService.rules.initial(this.INITIAL_ROUTE);
  }
}
